var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collapsible-panel"},[_c('div',{staticClass:"header",on:{"click":function($event){_vm.isOpen = !_vm.isOpen}}},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":_vm.staticArrow
          ? _vm.arrowImages[0]
          : _vm.isOpen
          ? _vm.arrowImages[1]
          : _vm.arrowImages[0],"alt":"toggle"}})]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }